module.exports = __webpack_public_path__ + "img/level_four_hover.41e61c68.png";